// This file is auto-generated - DO NOT EDIT - it will be overwritten. 

export const allEquipmentStatuses = {
	OK:"OK",
	Broken:"Broken",
	AtService:"AtService",
}
